export const CREDIT_PERIOD_MAX_LENGTH = "50";
